import { Injectable } from '@angular/core';
import { Toast, ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class ToasterNotificationService {
  constructor(private toastr: ToastrService) {}

  showSuccess(
    message: string,
    title: string = '',
    time: any = '',
    position: string = '',
    customToastComponent: any = ''
  ) {
    this.toastr.success(message, title, {
      timeOut: time && time != '' ? time : 1000,
      positionClass: position && position != '' ? position : 'toast-top-right',
      toastComponent: customToastComponent || Toast,
      disableTimeOut: false,
      closeButton: true,
      tapToDismiss: false,
      toastClass:
        customToastComponent && customToastComponent != ''
          ? 'toast-icon custom-toast-success custom'
          : 'ngx-toastr',
    });
  }

  showError(
    message: string,
    title: string = '',
    time: any = '',
    position: string = '',
    customToastComponent: any = ''
  ) {
    this.toastr.error(message, title, {
      timeOut: time && time != '' ? time : 100000,
      positionClass: position && position != '' ? position : 'toast-top-right',
      toastComponent: Toast,
      closeButton: true,
    });
  }

  showInfo(message: string, title: string) {
    this.toastr.info(message, title);
  }

  showWarning(message: string, title: string) {
    this.toastr.warning(message, title);
  }
}
